import { List } from "immutable";
import _ from "lodash";

import { createFromJS } from "../../types";
import combineReducersWithGlobal from "../combineReducersWithGlobal";
import rootActionTypes from "../rootActionTypes";
import { actionTypes } from "./actions";

const isVisible = (state = true, action) => {
  switch (action.type) {
    case actionTypes.SHOW_WELCOME:
    case actionTypes.UPDATE_ALL:
      return true;
    case actionTypes.HIDE_WELCOME:
    case rootActionTypes.LOAD_FILE:
    case rootActionTypes.UPDATE_FILE:
    case rootActionTypes.LOAD_SAMPLE:
      return false;
    default:
      return state;
  }
};

const showLoadingFile = (state = true, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LOADING_FILE:
      return true;
    case actionTypes.HIDE_LOADING_FILE:
    case actionTypes.SHOW_WELCOME:
    case actionTypes.HIDE_WELCOME:
    case rootActionTypes.LOAD_FILE:
    case rootActionTypes.UPDATE_FILE:
    case rootActionTypes.LOAD_SAMPLE:
    case actionTypes.SHOW_UPGRADE_WIZARD:
    case actionTypes.SHOW_TEMPLATE_WIZARD:
      return false;
    default:
      return state;
  }
};

const recentFiles = (state = List(), action) => {
  switch (action.type) {
    case actionTypes.UPDATE_RECENT_FILES: {
      return List(_.map(action.data, l => createFromJS.FileRecord(l)));
    }
    case actionTypes.UPDATE_ALL: {
      return List(_.map(action.data.recentFiles, l => createFromJS.FileRecord(l)));
    }
    default: {
      return state;
    }
  }
};

const exampleFiles = (state = List(), action) => {
  switch (action.type) {
    // case actionTypes.UPDATE_EXAMPLE_FILES:
    //   return List(_.map(action.data, l => createFromJS.FileRecord(l)));
    case actionTypes.UPDATE_ALL: {
      return List(
        _.map(action.data.exampleFiles, l =>
          createFromJS.FileRecord({
            name: l.name,
            fullPath: l.fileIdentifier
          })
        )
      );
    }
    default:
      return state;
  }
};

const customTemplates = (state = List(), action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CUSTOM_TEMPLATES:
      return List(_.map(action.data, l => createFromJS.WelcomeTemplateRecord(l)));
    case actionTypes.UPDATE_ALL:
      return List(_.map(action.data.customTemplates, l => createFromJS.WelcomeTemplateRecord(l)));
    case actionTypes.DELETE_CUSTOM_TEMPLATE:
      return state.filter(template => template.id !== action.data);
    default:
      return state;
  }
};

const showUpgradeWizard = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_UPGRADE_WIZARD:
      return true;
    case actionTypes.HIDE_UPGRADE_WIZARD:
    case actionTypes.HIDE_WELCOME:
      return false;
    default:
      return state;
  }
};

const incomingUpgradeData = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_UPGRADE_WIZARD:
      return action.data;
    case actionTypes.HIDE_UPGRADE_WIZARD:
    case actionTypes.HIDE_WELCOME:
      return null;
    default:
      return state;
  }
};

const showTemplateWizard = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_TEMPLATE_WIZARD:
      return true;
    case actionTypes.HIDE_TEMPLATE_WIZARD:
    case actionTypes.HIDE_WELCOME:
      return false;
    default:
      return state;
  }
};

const welcomeScreenReducer = combineReducersWithGlobal(createFromJS.WelcomeScreenRecord({}), {
  isVisible,
  recentFiles,
  exampleFiles,
  customTemplates,
  showUpgradeWizard,
  incomingUpgradeData,
  showTemplateWizard,
  showLoadingFile
});

export default welcomeScreenReducer;
